import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';
import { Guard } from '../models';
import { CmFeatureService, CmSettingsService } from '../services';

@Injectable()
export class CmPublicFeaturesGuard implements CanActivate {
	constructor(private router: Router, private settings: CmSettingsService, private features: CmFeatureService) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		return this.features.public$.pipe(
			filter(publicFeatures => !!publicFeatures),
			mergeMap(publicFeatures =>
				iif(
					() => (route.data || {}).features,
					of(
						Guard.HasSomeFeatures(route.data.features, publicFeatures) ||
							this.router.createUrlTree(this.settings.route(['access-denied']))
					),
					of(true)
				)
			),
			take(1)
		);
	}
}
